<template>
<div class="testimnoal_section" v-if="get_testimonial">
   <div class="container p-0">
    <div class="row">
        <div class="col-md-6">
            <div class="text_testi">
                 <h1 class="big_t">{{get_testimonial.title}}</h1>
                <h2 class="t1">{{get_testimonial.subtitle}}</h2>
                <h1 v-html="get_testimonial.description"></h1>
                <h3>{{get_testimonial.client_name}}</h3>
              <template v-if="get_testimonial.button">
                        <template v-if="get_testimonial.button.type=='internal'"> 
                              <router-link  class="more" :to="`/${get_testimonial.button.link}`">{{get_testimonial.button.text}} <i class='bx bxs-right-arrow'></i></router-link>
                        </template>
                        <template v-else>
                             <a class="more" :href="get_testimonial.button.link">{{get_testimonial.button.text}} <i class='bx bxs-right-arrow'></i></a>
                        </template>
              </template>
            </div>
        </div>
        <div class="col-md-6">
            <div class="img_user">
                <img :src="get_testimonial.image" :alt="get_testimonial.title">
            </div>
        </div>
    </div>
   </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "testimnoalArea",
       computed:{
    ...mapGetters({
        get_testimonial:'get_testimonial',
    })
  },
    methods:{
    ...mapActions({
       testimonial_api:'testimonial_api',
    }),
    },
    mounted(){
       this.testimonial_api();
    }
}
</script>
<style lang="scss" scoped>
.testimnoal_section{
    margin-top: 40px;
    background-image: url('~@/assets/testim.svg');
   background-position: 50vw 20vh;
   background-size: 80vw;
   background-repeat: no-repeat;

    .img_user{
        text-align: right;
        img{
              width: 90%;
    padding-top: 60px;
    padding-left: 0;
    height: 100%;
    margin-left: 90px;
        }
    }
    .text_testi{
        padding-top: 250px;
        h1.big_t{
         line-height: 1.1;
            margin: 0;
            color: white;
            font-size: 5rem;
            font-weight: 700;
            font-family: 'Oswald',sans-serif;
            text-transform: uppercase;
            display: block;
             margin-bottom: 50px;   
             margin-top: -80px;
        }
        h1{
            line-height: 1.1;
            margin: 0;
            color: white;
            font-size: 2.4rem;
            font-weight: 700;
            font-family: 'Oswald',sans-serif;
            text-transform: uppercase;
            display: block;
             margin-top: 50px;
             strong{
                color: white;
             }
        }
        h3{
    color: white;
    font-size: 1.5rem;
    font-weight: 700;
    font-family: 'Oswald',sans-serif;
    text-transform: uppercase;
    margin: 0;
    margin-top: 50px;
        }
        .more{
            margin-top: 120px;
        }
    }
}


// STYLE MEDIA QUERY
@media(max-width:992px){
.testimnoal_section .text_testi h1.big_t{
    font-size: 2rem;
}
.testimnoal_section .text_testi h1{
    line-height: 1.1;
    margin: 0;
    font-size: 1.4rem;
    margin-top: 30px;
}
.testimnoal_section {
    margin-top: 0px;
    background-position: 56vw 19vh;
    background-size: 60vw;
    background-repeat: no-repeat;
}
.testimnoal_section .img_user img{
    width: 100%;
}
.testimnoal_section .text_testi .more{
    margin-top: 40px;
}
.testimnoal_section .text_testi h3 {
    font-size: 1.1rem;
    margin: 0;
    margin-top: 30px;
}
h1 strong {
    font-size: 1.5rem;
    font-weight: 600;
    font-family: "Oswald", sans-serif;
    text-transform: uppercase;
    display: block;
    margin-top: 50px;
}
}
@media(max-width:767px){
    .testimnoal_section {
    margin-top: 0px;
    background-position: 22vw 64vh;
    background-size: 100vw;
    background-repeat: no-repeat;
}
.testimnoal_section .text_testi{
    padding-top: 150px;
    padding-left: 20px;
}
.testimnoal_section .img_user img{
    width: 90%;
}
}
</style>